import notifyError from './notify-error.js';

export default async ({ $vs, format, document, token }) => {
  try {
    return await axios.post(
      `http://127.0.0.1:58623/${ format }`,
      {
        api: import.meta.env.VITE_SITE_URL,
        document,
        token,
      },
    );
  } catch (error) {
    if ('Network Error' === error?.message) {
      notifyError({ $vs, title: 'Signer', text: 'Nie można połączyć się z aplikacją Signer.' });
      return null;
    }

    const exception = error?.response?.data?.message || '';

    if (/Unable to (?:instantiate|create) PKCS11(?: provider)?/.test(exception)) {
      notifyError({ $vs, title: 'Signer', text: 'Nie można połączyć się z urządzeniem kryptograficznym.' });
      return null;
    }

    if (exception.includes('Reason: load failed')) {
      notifyError({ $vs, title: 'Signer', text: 'Nie udało się podpisać dokumentu. Możliwy zły kod PIN.' });
      return null;
    }

    throw error;
  }
}
